// page builder framework theme js

import "./components/wpbf/site-min.2.10.3";
import "./components/wpbf/site.2.9.1";

// se presente ninjaform e datepicker includere:
import "./flatpickr-pw";

// you can import modules from the theme lib or even from
// NPM packages if they support it…
// import ExampleComponent1 from "./components/ExampleComponent1";

// you can also require modules if they support it…
// const ExampleModule2 = require('./components/example-2');

// Some convenient tools to get you started…
// import ReplaceObfuscatedEmailAddresses from "./components/ReplaceObfuscatedEmailAddresses";
// import AnimateOnPageLinks from "./components/AnimateOnPageLinks";

// import owl from "owl.carousel";
// import owlLoopContent from "./components/slider/owl-loop-content";
// import owlLoopOffer from "./components/slider/owl-loop-offer";
// import owlSlider from "./components/slider/owl-slider";
// import owlSliderGallery from "./components/slider/owl-gallery-slider";

// * TINY SLIDER
// https://ganlanyuan.github.io/tiny-slider/demo/
import tinySlider from "./components/slider/tiny-slider";

// SLICK CAROUSEL
// import slick from "slick-carousel";
// import slickSliderHero from "./components/slick-hero.js";
// var slider = new slickSliderHero();

// * READMORE JS
// https://www.npmjs.com/package/readmore-js
// require("readmore-js");

// * GSAP
//import "./components/anime";
//import "./components/scrollmagic";
//import "./components/gsap";

// * SIMPLELIGHTBOX
import simpleLightbox from "simple-lightbox";
var SimpleLightbox = require("simple-lightbox");

// * NINJA FORM PW
// import "./components/ninja-form-pw";

// Initialise our components on jQuery.ready…

// jQuery(function ($) {
//   ExampleComponent1.init();
//   ExampleModule2.init();
//   ReplaceObfuscatedEmailAddresses.init();
//   AnimateOnPageLinks.init();

//   owlLoopContent.init();
//   owlLoopOffer.init();
//   owlSlider.init();
// });

/*
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty("--vh", `${vh}px`);

window.addEventListener("resize", () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
});
*/

// * aggiungere nei css height: calc(var(--vh, 1vh) * 100) !important;
// https://github.com/Hiswe/vh-check
import vhCheck from "vh-check";
vhCheck({
  bind: false,
  redefineVh: true,
});

jQuery(function ($) {
  // *stops scrolling menufullscreen
  $("#wpbf-menu-toggle").click(function (e) {
    e.preventDefault();

    $("body").addClass("stop-scrolling");
  });

  $(".wpbf-close").click(function (e) {
    e.preventDefault();

    $("body").removeClass("stop-scrolling");
  });

  // *lightbox
  $(".simple-lightbox-container").each(function (idx) {
    $(this).find(".simple-lightbox a").simpleLightbox();
  });

  // *aggiungo id progressivo alle section
  $(".wp-block-group").each(function (i, div) {
    div.id = "sec" + (i + 1); //i starts at 0
  });

  //   * readmore
  //   ------------------------------------------
  //   $(".readmore").readmore({
  //     collapsedHeight: 180,
  //     embedCSS: false,
  //     speed: 75,
  //     moreLink: '<a href="#">Read more</a>',
  //     lessLink: '<a href="#">Close</a>',
  //   });

  //   if (polylang.isEnglish == true) {
  //     var more = "read more";
  //     var less = "read less";
  //   } else {
  //     var more = "scopri di più";
  //     var less = "chiudi";
  //   }
  //   $(".readmore-wrapper").readmore({
  //     moreLink: `<a class="readmore" href=""><span>...  ${more}</span></a>`,
  //     lessLink: `<a class="readmore" href=""><span>...  ${less}</span></a>`,
  //   });
  //   ------------------------------------------
  //   $(".menu-item-has-children").hover(function () {
  //     $(this).toggleClass("submenu-on");
  //   });
});

import AOS from "aos";
import "aos/dist/aos.css";
document.addEventListener("DOMContentLoaded", function () {
  // effetto zoom per repeater containter colonna immagine
  var immagine = document.querySelectorAll(".gallery-container");
  immagine.forEach(function (immagine) {
    immagine.setAttribute("data-aos", "zoom-out-right");
  });
  // effetto zoom per repeater containter colonna testo
  var contenuto = document.querySelectorAll(".contenuto");
  contenuto.forEach(function (contenuto) {
    contenuto.setAttribute("data-aos", "zoom-out-right");
  });
  // zoom-in effect for images in simple-lightbox
  var images = document.querySelectorAll(".simple-lightbox-container img");
  images.forEach(function (image) {
    image.setAttribute("data-aos", "zoom-in");
  });
  var decorativeSquares = document.querySelectorAll(".decorative-square");
  decorativeSquares.forEach(function (square) {
    square.setAttribute("data-aos", "fade-up");
  });
  // var btns = document.querySelectorAll(".btn");
  // btns.forEach(function (btn) {
  //   btn.setAttribute("data-aos", "fade-left");
  // });
  // var h1s = document.querySelectorAll("h1");
  // h1s.forEach(function (h1) {
  //   h1.setAttribute("data-aos", "fade-up");
  //   h1.setAttribute("data-aos-anchor", "acf-blocks");
  // });
  // inizializzo AOS
  AOS.init({
    duration: 800,
    offset: 200,
    easing: "ease-in-out",
    // once: true,
    disable: function () {
      return window.innerWidth <= 768;
    },
  });
});

/* scroll */

jQuery(document).ready(function ($) {
  // Verifica se nell'URL è presente un link ancora (ancora tipo #)
  if (window.location.hash) {
    // Ottieni l'ID dell'elemento a cui vuoi scorrere
    var targetElement = $(window.location.hash);

    // Verifica se l'elemento con l'ID specificato esiste
    if (targetElement.length) {
      // Calcola la posizione dell'elemento rispetto al documento
      var targetOffset = targetElement.offset().top;

      // Scrolla la pagina fino all'ancora
      $("html, body").animate(
        {
          scrollTop: targetOffset,
        },
        500,
      ); // Puoi regolare la velocità dello scroll cambiando il valore 1000 (1 secondo)
    }
  }
});
